import slugify from './slugify';

export default (name: string, id: string | number) => {
    return `${slugify(name)}-(${id.toString()})`;
};
